<template>
  <div id="sidebar-menu">
    <!-- {{layoutobject}}
          fdsfdsf{{[layoutobject.split(' ').includes('horizontal-wrapper')]}} -->
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="[
        layoutobject.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { '  -right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
          <!-- <div class="mobile-back text-end">
              <span>Back</span
              ><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
          </div> -->
      </li>

      <!-- GENERAL Group -->
      <li class="pt-2 pl-5">
        <div class="sidebar-part">
          <el-row span="24" class="w-100-p">
            <el-col span="20">
              <h6 class="lan-1 moderat-light-bold" style="min-width: 200px">
                GENERAL
              </h6>
            </el-col>
            <el-col span="4" style="text-align: center">
              <el-image
                class="arrow-btn"
                style="width: 14px; height: 14px"
                :src="generalOpen ? require('@/assets/arrow-right.png') : require('@/assets/arrow-left.png')"
                fit="cover"
                @click="generalOpen = !generalOpen"
              />
            </el-col>
          </el-row>
        </div>
      </li>

      <li class="sidebar-list" v-show="generalOpen">
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard"
        >
          <svg class="stroke-icon" >
            <use href="@/assets/svg/icon-sprite.svg#home-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold">
            Home
            <el-tooltip
              v-if="isDashboardHighlightsProcessing"
              content="Highlights are computing in the background. This page will update when results are ready."
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>
      <li
        class="sidebar-list"
        v-show="generalOpen"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/summary"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#summary-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#summary-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Summary </span>
        </router-link>
      </li>

      <!-- Auditor Reports -->
      <li
        v-show="generalOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-auditor-reports"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#auditor-report-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#auditor-report-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Auditor Reports
            <el-tooltip
              v-if="isAuditorReportsProcessing"
              :content="getTooltipText('auditor_reports')"
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>
      <!-- Auditor Reports -->

      <!-- Verra Reports -->
      <li
        v-show="generalOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-verra-reports"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#verra-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#verra-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Verra Reports
            <el-tooltip
              v-if="isVerraReportsProcessing"
              :content="getTooltipText('verra_reports')"
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>
      <!-- Verra Reports -->

      <!-- DMRV  -->
      <li
        v-show="generalOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-DMRV"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#dmrv-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#dmrv-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> DMRV </span>
        </router-link>
      </li>
      <!-- DMRV  -->

      <!-- Snapshot Reports -->
      <!-- <li
        v-show="generalOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-snapshot-reports"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#snapshot-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#snapshot-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Snapshot Reports </span>
        </router-link>
      </li> -->
      <!-- Snapshot Reports -->

      <!-- Overlap Sessions -->
      <li
        v-show="generalOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-overlap-sessions"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#overlap-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#overlap-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Overlap Sessions </span>
        </router-link>
      </li>
      <!-- Overlap Sessions -->

      <!-- GENERAL Group -->

      <!-- INSIGHTS group -->

      <li class="pt-2 pl-5">
        <div class="sidebar-part">
          <el-row span="24" class="w-100-p">
            <el-col span="20">
              <h6 class="lan-1 moderat-light-bold" style="min-width: 200px">
                INSIGHTS
              </h6>
            </el-col>
            <el-col span="4" style="text-align: center">
              <el-image
                class="arrow-btn"
                style="width: 14px; height: 14px"
                :src="insightsOpen ? require('@/assets/arrow-right.png') : require('@/assets/arrow-left.png')"
                fit="cover"
                @click="insightsOpen = !insightsOpen"
              />
            </el-col>
          </el-row>
        </div>
      </li>

      <!-- Charger Anomaly -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-charger-anomaly"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#charger-anormaly-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#charger-anormaly-icon"
            ></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Charger Anomaly </span>
        </router-link>
      </li>

      <!-- Charger -->
      <li v-show="insightsOpen" class="sidebar-list">
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-chargers"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#chargers-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#chargers-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Chargers </span>
        </router-link>
      </li>
      <!-- Session -->
      <li v-show="insightsOpen" class="sidebar-list">
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-sessions"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#stroke-widget"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-widget"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Sessions 
            <el-tooltip
              v-if="isLoading('session')"
              :content="getTooltipText('session')"
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>

      <!-- Abatement within Radius -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-abatement-within-radius"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#abatement-map-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#abatement-map-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Abatement Map </span>
        </router-link>
      </li>
      <!-- TimeOfDay -->
      <li v-show="insightsOpen" class="sidebar-list">
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-time-of-day"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#stroke-new-time"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-new-time"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Time of Day </span>
        </router-link>
      </li>

      <!-- Renewable Energy Analytics -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-renewable-energy-analytics"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/newSvgIcon.svg#renew-energy-analytics"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/newSvgIcon.svg#renew-energy-analytics"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Onsite Renewables </span>
        </router-link>
      </li>

      <!-- Live Abatement -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-abatement"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#live-abatement-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#live-abatement-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Live Abatement </span>
        </router-link>
      </li>

      <!-- Fleet Analytics -->
      <li
        v-show="insightsOpen"
        v-if="showFleetAnalytics"
        class="sidebar-list"
      >
        <router-link class="sidebar-link sidebar-title" to="/fleet-analytics">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#vehicles-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#vehicles-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Fleet Analytics </span>
        </router-link>
      </li>

      <!-- Estimator -->
      <!-- <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-estimator"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#estimator-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#estimator-icon"></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Estimator </span>
        </router-link>
      </li> -->
      <!-- Estimator -->

      <!-- Vehicles -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <router-link class="sidebar-link sidebar-title" to="/vehicles">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#vehicles-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#vehicles-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Vehicles </span>
        </router-link>
      </li>

      <!-- Bucket Files -->
      <li
        v-show="insightsOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null"
      >
        <router-link class="sidebar-link sidebar-title" to="/motion-drive">
          <svg class="stroke-icon">
            <use href="@/assets/svg/newSvgIcon.svg#motion-drive-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/newSvgIcon.svg#motion-drive-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Motion Drive </span>
        </router-link>
      </li>

      <!-- dashboard old -->
      <!-- <li class="sidebar-list">
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/dashboard-old"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#stroke-home"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-home"></use>
          </svg>
          <span class="lan-3 moderat-white-bold">Home Old</span>
        </router-link>
      </li> -->


      <!-- INSIGHTS group -->

      <!-- INPUT group-->

      <li
        class="pt-2 pl-5"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <div class="sidebar-part">
          <el-row span="24" class="w-100-p">
            <el-col span="20">
              <h6 class="lan-1 moderat-light-bold" style="min-width: 200px">
                INPUT
              </h6>
            </el-col>
            <el-col span="4" style="text-align: center">
              <el-image
                class="arrow-btn"
                style="width: 14px; height: 14px"
                :src="inputOpen ? require('@/assets/arrow-right.png') : require('@/assets/arrow-left.png')"
                fit="cover"
                @click="inputOpen = !inputOpen"
              />
            </el-col>
          </el-row>
        </div>
      </li>

      <!-- Users -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <router-link class="sidebar-link sidebar-title text-white" to="/users">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#stroke-user"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-user"></use>
          </svg>
          <span class="moderat-white-bold"> Users </span>
        </router-link>
      </li>
      <!-- Customers -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <router-link class="sidebar-link sidebar-title" to="/customers">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#customers-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#customers-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Customers 
            <el-tooltip
              v-if="isAbatementCalculateProcessing"
              content="Task in progress. You will be notified once it is complete."
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>

      <!-- <li
        class="pt-2 pl-5"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <div>
          <h6 class="lan-1 moderat-light-bold">Input</h6>
        </div>
      </li> -->

      <!-- Nemotion Validation -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/nemotion-validation"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <span class="lan-3 moderat-white-bold"> Nemotion Validation </span>
        </router-link>
      </li>
      <!-- UK emission intenesity -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <label class="badge badge-light-primary"> </label>
        <router-link
          class="sidebar-link sidebar-title text-white"
          to="/uk-emission-intensity"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <span class="lan-3 moderat-white-bold">UK Emission Intensity
            <el-tooltip
              v-if="isUkEmissionIntensityUpdateProcessing"
              content="Task in progress. You will be notified once it is complete."
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>

      <!-- Baseline Params -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link class="sidebar-link sidebar-title" to="/baseline-params">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#baseline-params"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#baseline-params"></use>
          </svg>
          <span class="moderat-white-bold"> Baseline Params </span>
        </router-link>
      </li>
      <!-- Site Baseline Params -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link
          class="sidebar-link sidebar-title"
          to="/site-baseline-params"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#site-baseline-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#site-baseline-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Site Baseline Params </span>
        </router-link>
      </li>
      <!-- Emission Intensity -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link class="sidebar-link sidebar-title" to="/factors/emission-intensity">
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#nemotion-validation-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold">Emission Factors</span>
        </router-link>
      </li>
      <!-- Participants -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <router-link class="sidebar-link sidebar-title" to="/participants">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#participants-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#participants-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Participants </span>
        </router-link>
      </li>

      <!-- On Site Renewable -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link class="sidebar-link sidebar-title" to="/on-site-renewable">
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Onsite Renewable </span>
        </router-link>
      </li>
      <!-- Monitoring Periods -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link
          class="sidebar-link sidebar-title"
          to="/monitoring-periods"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#monitoring-period-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#monitoring-period-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Monitoring Periods </span>
        </router-link>
      </li>
      <!-- Battery Intensities -->
      <li
        v-show="inputOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin"
      >
        <router-link
          class="sidebar-link sidebar-title"
          to="/battery-intensities"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#battery"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#battery"></use>
          </svg>
          <span class="moderat-white-bold"> Battery Intensities </span>
        </router-link>
      </li>


      <!-- INPUT group-->

      <!-- OPERATION group -->
      <template
        v-if="
          $store.state.auth.user != null && !$store.state.auth.user.is_auditor
        "
      >
      <li class="pt-2 pl-5">
        <div class="sidebar-part">
          <el-row span="24" class="w-100-p">
            <el-col span="20">
              <h6 class="lan-1 moderat-light-bold" style="min-width: 200px">
                OPERATION
              </h6>
            </el-col>
            <el-col span="4" style="text-align: center">
              <el-image
                class="arrow-btn"
                style="width: 14px; height: 14px"
                :src="operationOpen ? require('@/assets/arrow-right.png') : require('@/assets/arrow-left.png')"
                fit="cover"
                @click="operationOpen = !operationOpen"
              />
            </el-col>
          </el-row>
        </div>
      </li>
      <!-- Charger -->
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/admin-upload-charging-schedule'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Charger Upload </span>
        </router-link>
      </li>
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/charging-sites'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Charger List </span>
        </router-link>
      </li>
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/admin-onsite-renewables'"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Renewables / BESS </span>
        </router-link>
      </li>
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/admin-upload-session'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#sessions-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#sessions-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Session Upload </span>
        </router-link>
      </li>
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/generate-sessions-file-csv'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#sessions-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#sessions-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Session CSV Export </span>
        </router-link>
      </li>
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_admin
          "
          :to="'/upload-chargers'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#operation-chargers-icon"
            ></use>
          </svg>
          <span class="moderat-white-bold"> Chargers </span>
        </router-link>
      </li>
      <!-- Session -->
      <li v-show="operationOpen" class="sidebar-list">
        <!-- <a class="sidebar-link sidebar-title" href="#" target="_blank"> -->
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/sessions'"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#sessions-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#sessions-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Delete Sessions </span>
        </router-link>
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_admin
          "
          :to="'/upload-sessions'"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#sessions-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#sessions-icon"></use>
          </svg>
          <span class="moderat-white-bold"> Sessions
            <el-tooltip
              v-if="isSessionUploadProcessing"
              content="Task in progress. You will be notified once it is complete."
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>


      <!-- Renewable Energy -->
      <li 
        v-show="operationOpen"
        class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_admin
          "
          :to="'/upload-onsite-renewables'"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#onsite-renewable-icon"></use>
          </svg>
          <span class="moderat-white-bold"> 
            Renewables / BESS
            <el-tooltip
              v-if="isOnsiteRenewablesUploadProcessing"
              content="Task in progress. You will be notified once it is complete."
              placement="right"
            >
              <span class="renewable-loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </el-tooltip>
          </span>
        </router-link>
      </li>

      <!-- OPERATION group -->

      <!-- Fleet -->
      <li v-show="operationOpen" class="sidebar-list">
        <router-link
          class="sidebar-link sidebar-title"
          v-if="showFleetUpload"
          :to="'/upload-fleet'"
        >
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#stroke-to-do"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-to-do"></use>
          </svg>
          <span class="moderat-white-bold"> Fleet </span>
        </router-link>
      </li>
      </template>
      <li
        class="pt-2 pl-5"
        v-if="
          $store.state.auth.user != null && !$store.state.auth.user.is_auditor
        "
      >
        <div class="sidebar-part">
          <el-row span="24" class="w-100-p">
            <el-col span="20">
              <h6 class="lan-1 moderat-light-bold" style="min-width: 200px">
                SUPPORT
              </h6>
            </el-col>
            <el-col span="4" style="text-align: center">
              <el-image
                class="arrow-btn"
                style="width: 14px; height: 14px"
                :src="supportOpen ? require('@/assets/arrow-right.png') : require('@/assets/arrow-left.png')"
                fit="cover"
                @click="supportOpen = !supportOpen"
              />
            </el-col>
          </el-row>
        </div>
      </li>
      <!-- History Log -->
      <li
        v-show="supportOpen"
        class="sidebar-list"
        v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && !$store.state.auth.user.is_auditor"
      >
        <router-link class="sidebar-link sidebar-title" to="/history-logs">
          <svg class="stroke-icon">
            <use href="@/assets/svg/icon-sprite.svg#historylog-icon"></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#historylog-icon"></use>
          </svg>
          <span class="moderat-white-bold"> History Log </span>
        </router-link>
      </li>
      <!-- Support Ticket -->
      <li
        v-show="supportOpen"
        class="sidebar-list"
        v-if="
          $store.state.auth.user != null && !$store.state.auth.user.is_auditor
        "
      >
        <!-- <a class="sidebar-link sidebar-title" href="#" target="_blank"> -->
        <router-link
          class="sidebar-link sidebar-title"
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :to="'/supports'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#stroke-support-tickets"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-support-tickets"></use>
          </svg>
          <span class="moderat-white-bold"> Support Ticket </span>
        </router-link>
        <router-link
          v-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_admin
          "
          class="sidebar-link sidebar-title mb-20"
          :to="'/tickets'"
        >
          <svg class="stroke-icon">
            <use
              href="@/assets/svg/icon-sprite.svg#stroke-support-tickets"
            ></use>
          </svg>
          <svg class="fill-icon">
            <use href="@/assets/svg/icon-sprite.svg#fill-support-tickets"></use>
          </svg>
          <span class="moderat-white-bold"> Support Ticket </span>
        </router-link>
        <div
          disabled
          v-if="
            $store.state.auth.user != null
          "
          style="height: 40px; margin-top: 20px; background-color: #0D3937; border-color: #0D3937;"
        >
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { layoutClasses } from "../../constants/layout";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Navmenu",
  data() {
    return {
      layoutobj: {},

      // control open and close icon group
      generalOpen: true,
      insightsOpen: true,
      inputOpen: true,
      operationOpen: true,
      supportOpen: true,

    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      sidebar: (state) => state.layout.sidebarType,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
      width: (state) => state.menu.width,
      height: (state) => state.menu.height,
      margin: (state) => state.menu.margin,
      menuWidth: (state) => state.menu.menuWidth,
      isRenewableProcessing: (state) => state.renewableProcessing.isProcessing,
      isAbatementCalculateProcessing: (state) => state.tasksProcessing.isAbatementCalculateProcessing,
      isUkEmissionIntensityUpdateProcessing: (state) => state.tasksProcessing.isUkEmissionIntensityUpdateProcessing,
    }),

    // Tasks Processing
    ...mapGetters('tasksProcessing', [
      'isLoading', 
      'getTaskStatus', 
      'getTaskType',
      'isSessionProcessing',
      'isChargerProcessing',
      'isSessionUploadProcessing',
      'isOnsiteRenewablesUploadProcessing',
      'isAbatementCalculateProcessing',
      'isDashboardHighlightsProcessing',
      'isAuditorReportsProcessing',
      'isVerraReportsProcessing',
      'isUkEmissionIntensityUpdateProcessing'
    ]),
    // Tasks Processing

    // control fleet upload display
    showFleetUpload() {
      if (this.$store.state.auth.user != null && !this.$store.state.auth.user.is_admin) {
        if (this.$store.state.auth.user.private_fleet) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    showFleetAnalytics() {
      if (this.$store.state.auth.user != null && this.$store.state.auth.user.is_auditor) {
        return false;
      }
      // if user is admin, show fleet analytics
      if (this.$store.state.auth.user != null && this.$store.state.auth.user.is_admin) {
        return true;
      } else {
        // if user is not admin, check if user is active and has private fleet, if so, return show fleet analytics
        if (!this.$store.state.auth.user || !this.$store.state.auth.user.is_active) {
          return false;
        } else if (!this.$store.state.auth.user.private_fleet) {
          return false;
        } else {
          return true;
        }
      }
    },

    layoutobject: {
      get: function () {
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) => Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  watch: {
    width() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      window.addEventListener("scroll", this.handleScroll);
      this.handleScroll();
      if (window.innerWidth < 992) {
        const newlayout = JSON.parse(
          JSON.stringify(this.layoutobject).replace(
            "horizontal-wrapper",
            "compact-wrapper"
          )
        );
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + newlayout;
        this.$store.state.menu.margin = 0;
      } else {
        document.querySelector(".page-wrapper").className =
          "page-wrapper " + this.layoutobject;
      }

      if (
        (window.innerWidth < 1199 && this.layout.settings.layout === "Tokyo") ||
        (window.innerWidth < 1199 &&
          this.layout.settings.layout === "Moscow") ||
        (window.innerWidth < 1199 && this.layout.settings.layout === "Rome")
      ) {
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      }
    },

    // watch for toggler sidebar to open all group
    // make sure to show all icon when sidebar is closed
    togglesidebar(newVal) {
      if (newVal == false) {
        this.openAll();
      }
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (this.$store.state.menu.width < 991) {
      this.layout.settings.layout = "Dubai";
      this.margin = 0;
    }
    setTimeout(() => {
      const elmnt = document.getElementById("myDIV");
      this.$store.state.menu.menuWidth = elmnt == null ? 0 : elmnt.offsetWidth;
      this.$store.state.menu.menuWidth > window.innerWidth
        ? ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = false))
        : ((this.$store.state.menu.hideRightArrow = false),
          (this.$store.state.menu.hideLeftArrowRTL = true));
    }, 500);
    this.layoutobject = layoutClasses.find(
      (item) => Object.keys(item).pop() === this.layout.settings.layout
    );
    this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[
      this.layout.settings.layout
    ];
  },
  // destroyed() {
  //   window.removeEventListener('resize', this.handleResize);
  // },
  mounted() {

    this.menuItems.filter((items) => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter((subItems) => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });

  },
  methods: {
    // Tasks Processing
    ...mapActions('tasksProcessing', [
      'startLoading', 
      'stopLoading', 
      'completeTask', 
      'failTask'
    ]),

        // get tooltip text for each task
        getTooltipText(itemKey) {
      const status = this.getTaskStatus(itemKey);
      // const type = this.getTaskType(itemKey);
      
      switch (itemKey) {
        case 'renewable':
          return `Renewable energy processing: ${status}`;
        case 'session':
          return `Session data processing: ${status}`;
        case 'session_upload':
          return `Session upload processing: ${status}`;
        case 'onsite_renewables_upload' :
          return `Onsite renewables upload processing: ${status}`;
        case 'charger':
          return `Charger update: ${status}`;
        case 'fleet':
          return `Fleet data processing: ${status}`;
        case 'abatement_calculate':
          return `Abatement calculation processing: ${status}`;
        case 'uk_emission_intensity_update':
          return `UK emission intensity update processing: ${status}`;
        case 'auditor_reports':
          return `Auditor reports are computing in the background (${status}). Tables update as each section finishes.`;
        case 'verra_reports':
          return `Verra reports are computing in the background (${status}). Tables update as each section finishes.`;
        default:
          return `Task in progress: ${status}`;
      }
    },

    // call this function when task is complete
    finishSessionTask() {
      this.completeTask('session');
    },

    // example of usage of startLoading
    // startSessionTask() {
    //   this.startLoading({
    //     itemKey: 'session',
    //     taskId: 'session_task_456',
    //     taskType: 'session_processing',
    //     status: 'PENDING'
    //   });
    // },

    // Tasks Processing


    openAll() {
      this.generalOpen = true;
      this.insightsOpen = true;
      this.inputOpen = true;
      this.operationOpen = true;
      this.supportOpen = true;
    },
    handleScroll() {
      if (window.scrollY > 400) {
        if (
          this.layoutobject.split(" ").pop() === "material-type" ||
          this.layoutobject.split(" ").pop() === "advance-layout"
        )
          document.querySelector(".sidebar-main").className =
            "sidebar-main hovered";
      } else {
        if (document.getElementById("sidebar-main"))
          document.querySelector(".sidebar-main").className = "sidebar-main";
      }
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
      if (
        this.layoutobject.split(" ").includes("compact-sidebar") &&
        window.innerWidth > 991
      ) {
        if (this.menuItems.some((menuItem) => menuItem.active === true)) {
          this.$store.state.menu.activeoverlay = true;
        } else {
          this.$store.state.menu.activeoverlay = false;
        }
      }
    },
    hidesecondmenu() {
      if (window.innerWidth < 991) {
        (this.$store.state.menu.activeoverlay = false),
          (this.$store.state.menu.togglesidebar = false);
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      } else if (this.layoutobject.split(" ").includes("compact-sidebar")) {
        (this.$store.state.menu.activeoverlay = false),
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
      }
    },
    handleResize() {
      this.$store.state.menu.width = window.innerWidth - 450;
    },
  },
};
</script>

<style scoped>
/* .stroke-icon,
.stroke-icon use,
.fill-icon,
.fill-icon use {
  fill: white;
  stroke: white;
} */

.renewable-loading {
  margin-left: 10px;
  color: #ffffff;
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  /* Ensure high contrast with text shadow */
  text-shadow: 1px 1px 2px rgba(12, 132, 148, 0.822);
  /* Fallback for very dark backgrounds */
  filter: drop-shadow(0 0 3px rgba(12, 132, 148, 0.9));
}

.renewable-loading i {
  animation: spin 1s linear infinite;
  color: #ffffff;
  /* Ensure high contrast with text shadow */
  text-shadow: 1px 1px 2px rgba(12, 132, 148, 0.8);
  /* Fallback for very dark backgrounds */
  filter: drop-shadow(0 0 3px rgba(12, 132, 148, 0.9));
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* .active-item {
  background-color: #234B49;
  border-color: #234B49;
  border-style: none none none solid;
  border-width: 1px;
  border-radius: 6px;
  margin-left: 3px;
  margin-right: 3px;
  margin-right: 3px;
  min-width: 42px;
  min-width: 40px;
  
} */
</style>
